export default __webpack_public_path__ + "static/media/section2-bg2.f01d3cfa.png";